"use client";

import { useEffect } from "react";

/** Падение рендера страницы: сообщаем пользователю и пишем в журнал.
 *
 * Без этого экран просто белеет, а причина известна только в консоли вкладки. */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    fetch("/api/client-error", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        where: "падение страницы",
        msg: `${error.name}: ${error.message}`,
        trace: error.stack,
        url: typeof location !== "undefined" ? location.pathname : "",
      }),
      keepalive: true,
    }).catch(() => {});
  }, [error]);

  return (
    <html lang="ru">
      <body style={{ background: "#0f1115", color: "#e7e6e3", fontFamily: "system-ui" }}>
        <div style={{ maxWidth: 560, margin: "18vh auto", padding: "0 24px" }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 10px" }}>Страница упала</h1>
          <p style={{ color: "#a9adb3", lineHeight: 1.6, margin: "0 0 18px" }}>
            Ошибка записана в журнал (Настройки → Журнал падений). Данные не потеряны — правки
            хранятся в каталоге, а не на странице.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              background: "#2f2a5e",
              color: "#e7e6e3",
              border: "1px solid #4b4590",
              borderRadius: 8,
              padding: "8px 16px",
              cursor: "pointer",
            }}
          >
            Попробовать снова
          </button>
        </div>
      </body>
    </html>
  );
}
